import { render } from "./Slider.vue?vue&type=template&id=52077df6"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=52077df6&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__